import Validator, { RegisterCallback } from 'validatorjs';

type RuleCallbacks = {
  [key: string]: RegisterCallback;
};

const rules: RuleCallbacks = {
  not(this: any, val) {
    const req = this.getParameters();
    if (typeof val === 'string') {
      return !req.includes(val.trim());
    }
    return true;
  },
  multiplicationOf(this: any, value) {
    const req = this.getParameters();
    return Number(value) % Number(req) === 0;
  },
};

Validator.registerImplicit(
  'not',
  rules.not,
  'The :attribute field contains a disallowed value.',
);

Validator.registerImplicit(
  'multiplicationOf',
  rules.multiplicationOf,
  'The :attribute field contains a disallowed value.',
);

/**
 * @deprecated use RHF and YUP
 */
export { Validator };
